module.exports = __webpack_public_path__ + "img/TX-alt.e4e404fd.svg";